// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__7Loof","label":"Labeled_label__1Bkt-","divider":"Labeled_divider__34bUa"};